<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand v-if="this.$settings.owner==='nrc'" class="d-md-down-none" to="/">
      <CIcon
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        :height="25"
        viewBox="0 0 120 27"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="25"
        viewBox="0 0 120 27"
      />
    </CSidebarBrand>
    <CSidebarBrand v-else class="d-md-down-none" to="/">
      <img src="/static/ds/logo-full.png" class="c-sidebar-brand-full">
      <img src="/static/ds/logo-minimized.png" class="c-sidebar-brand-minimized">
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>

<style scoped>
  .logo-text {
    /*font-style: italic;*/
    color: silver;
    margin: 0px 0px;
    height: 100%;
    padding-top: 18.5px;
    padding-left: 2px;
    vertical-align: bottom;
  }
</style>
